import store from 'utils/store/withMiddleware'

function handleSort() {
  let sortBy = this.value
  const state = store.getState()
  const [currentSort, direction] = state.sortBy.split('-')

  if (currentSort === sortBy) {
    sortBy += direction ? '' : '-desc'
  }

  store.update({ sortBy })
}

export default handleSort
